import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Dropdown } from "../ui/dropdown/Dropdown";
import { fetchRappels } from "../../store/slices/rappelSlice";
import moment from "moment";

const NotificationDropdown = (props: any) => {
  const [isOpen, setIsOpen] = useState(false);

  const rappels: any[] = props.rappel?.rappels || [];

  useEffect(() => {
    props.fetchRappels();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const count = rappels.length;

  return (
    <div className="relative">
      <button
        className="relative flex items-center justify-center text-gray-500 transition-colors bg-white border border-gray-200 rounded-full hover:text-gray-700 h-11 w-11 hover:bg-gray-100 dark:border-gray-800 dark:bg-gray-900 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white"
        onClick={() => setIsOpen(!isOpen)}
      >
        {count > 0 && (
          <span className="absolute -top-0.5 -right-0.5 z-10 flex h-4 w-4 items-center justify-center rounded-full bg-cyan-500 text-[10px] font-bold text-white">
            {count > 9 ? "9+" : count}
          </span>
        )}
        {/* Icône cloche / alertes */}
        <svg className="fill-current" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path fillRule="evenodd" clipRule="evenodd"
            d="M10 2a6 6 0 00-6 6v2.586l-.707.707A1 1 0 004 13h12a1 1 0 00.707-1.707L16 10.586V8a6 6 0 00-6-6zm0 16a2 2 0 01-2-2h4a2 2 0 01-2 2z"
            fill="currentColor"
          />
        </svg>
      </button>

      <Dropdown
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        className="absolute -right-[200px] mt-[17px] flex h-auto max-h-[420px] w-[300px] flex-col rounded-xl border border-gray-200 bg-white p-3 shadow-lg dark:border-gray-800 dark:bg-gray-dark lg:right-0"
      >
        {/* En-tête */}
        <div className="flex items-center justify-between pb-3 mb-2 border-b border-gray-100 dark:border-gray-700">
          <h5 className="text-sm font-semibold text-gray-800 dark:text-gray-200">
            Alertes
            {count > 0 && (
              <span className="ml-2 inline-flex items-center justify-center px-1.5 py-0.5 rounded-full bg-cyan-100 text-cyan-700 text-xs font-bold">
                {count}
              </span>
            )}
          </h5>
          <button
            onClick={() => setIsOpen(false)}
            className="text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300"
          >
            <svg className="fill-current" width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd"
                d="M6.21967 7.28131C5.92678 6.98841 5.92678 6.51354 6.21967 6.22065C6.51256 5.92775 6.98744 5.92775 7.28033 6.22065L11.999 10.9393L16.7176 6.22078C17.0105 5.92789 17.4854 5.92788 17.7782 6.22078C18.0711 6.51367 18.0711 6.98855 17.7782 7.28144L13.0597 12L17.7782 16.7186C18.0711 17.0115 18.0711 17.4863 17.7782 17.7792C17.4854 18.0721 17.0105 18.0721 16.7176 17.7792L11.999 13.0607L7.28033 17.7794C6.98744 18.0722 6.51256 18.0722 6.21967 17.7794C5.92678 17.4865 5.92678 17.0116 6.21967 16.7187L10.9384 12L6.21967 7.28131Z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>

        {/* Liste des alertes */}
        <ul className="flex flex-col overflow-y-auto custom-scrollbar divide-y divide-gray-100 dark:divide-gray-800">
          {count === 0 ? (
            <li className="px-3 py-6 text-center">
              <p className="text-xs text-gray-400 mb-3">Aucune alerte</p>
              <Link
                to="/MonEspace?tab=alertes"
                onClick={() => setIsOpen(false)}
                className="inline-flex items-center gap-1 px-3 py-1.5 bg-cyan-500 hover:bg-cyan-600 text-white text-xs font-medium rounded-lg transition-colors"
              >
                <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                </svg>
                Créer une alerte
              </Link>
            </li>
          ) : (
            rappels.map((rappel: any) => (
              <li key={rappel.id}>
                <Link
                  to="/MonEspace?tab=alertes"
                  onClick={() => setIsOpen(false)}
                  className="flex items-start gap-3 px-3 py-2.5 hover:bg-gray-50 dark:hover:bg-white/5 transition-colors"
                >
                  <span className="flex-shrink-0 mt-0.5 w-5 h-5 rounded-full bg-cyan-100 flex items-center justify-center">
                    <svg className="w-3 h-3 text-cyan-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
                    </svg>
                  </span>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs text-gray-700 dark:text-gray-300 truncate">
                      {rappel.details || "Alerte sans titre"}
                    </p>
                    {rappel.date && (
                      <p className="text-[10px] text-gray-400 mt-0.5">
                        {moment(rappel.date).format("DD/MM/YYYY")}
                      </p>
                    )}
                  </div>
                </Link>
              </li>
            ))
          )}
        </ul>

        {/* Pied — lien vers toutes les alertes */}
        {count > 0 && (
          <Link
            to="/MonEspace?tab=alertes"
            onClick={() => setIsOpen(false)}
            className="block mt-3 px-4 py-2 text-xs font-medium text-center text-cyan-700 bg-cyan-50 border border-cyan-200 rounded-lg hover:bg-cyan-100 dark:border-cyan-800 dark:bg-cyan-900/20 dark:text-cyan-400 transition-colors"
          >
            Voir toutes les alertes
          </Link>
        )}
      </Dropdown>
    </div>
  );
};

const mapStateToProps = (state: any) => ({ rappel: state.rappel });
const mapDispatchToProps = { fetchRappels };

export default connect(mapStateToProps, mapDispatchToProps)(NotificationDropdown);
